import React from 'react'

export default function AboutGallery({galleryData}) {
  return (
    <>
    <section className="aboutpage-gallery">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <div className="aboutgallery-box">
                        <div>
                            <img src={galleryData.image1} alt="About" loading="lazy" className="wow animate__animated animate__fadeInLeft" data-wow-delay="0.2s" data-wow-duration="1s"/>
                            {galleryData?.desc && <p>{galleryData.desc}</p>}
                        </div>

                        <img src={galleryData.image2} className="img-responsive " alt="About" loading="lazy"/>
                    </div>

                    {galleryData?.desc && <p className='aboutgallery-mobile'>{galleryData.desc}</p>}
                </div>

            </div>
        </div>
    </section> 
    </>
  )
}
